import APIService from '../api.service';

export const SalesPivotReport = (params) => {
  return APIService.get(`/v01/reports/sales-pivot`, {
    params: {
      ...params
    },
  });
};

export const SalesReport = (params) => {
  return APIService.get(`/v01/reports/sales`, {
    params: {
      ...params
    },
  });
};

export const OrderReport = (params) => {
  return APIService.get(`/v01/reports/orders`, {
    params: {
      ...params
    },
  });
};

export const OrderPivotReport = (params) => {
  return APIService.get(`/v01/reports/orders-pivot`, {
    params: {
      ...params
    },
  });
};

export const Products = (params) => {
  return APIService.get(`/v01/products`);
};

export const FinancialOverview = (params) => {
  return APIService.get(`/v01/financial-overview`, {
    params: {
      ...params
    },
  });
};

export const CountOverview = () => {
  return APIService.get(`/v01/count-overview`);
};

export const PendingActions = () => {
  return APIService.get(`/v01/pending-actions`);
};

export const FetchItemQuantity = (params) => {
  return APIService.get(`/v01/fulfillment-status`, {
    params: {
      ...params
    },
  });
};

export const FetchQtySummary = (params) => {
  return APIService.get(`/v01/qty-summary`, {
    params: {
      ...params
    },
  });
};

export const PurchasePivotReport = (params) => {
  return APIService.get(`/v01/reports/purchase-pivot`, {
    params: {
      ...params
    },
  });
};

export const BillsPivotReport = (params) => {
  return APIService.get(`/v01/reports/bills-pivot`, {
    params: {
      ...params
    },
  });
};

export const PaymentsMadeReport = (params) => {
  return APIService.get(`/v01/reports/payments-made`, {
    params: {
      ...params
    },
  });
};

export const PaymentsMadeExport = (params) => {
  return APIService.get(`/v01/reports/payments-made/export`, {
    params: {
      ...params
    },
    responseType: 'blob',
  });
};

export const StockMovementPivotReport = (params) => {
  return APIService.get(`/v01/reports/stock-movement-pivot`, {
    params: {
      ...params
    },
  });
};

export const StockPivotReport = (params) => {
  return APIService.get(`/v01/reports/stock-pivot`, {
    params: {
      ...params
    },
  });
};

export const StockPivotExport = (params) => {
  return APIService.get(`/v01/reports/stock-pivot/export`, {
    params: {
      ...params
    },
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

const ReportService = {
  SalesPivotReport,
  SalesReport,
  OrderReport,
  Products,
  FinancialOverview,
  CountOverview,
  PendingActions,
  FetchItemQuantity,
  FetchQtySummary,
  OrderPivotReport,
  PurchasePivotReport,
  BillsPivotReport,
  PaymentsMadeReport,
  PaymentsMadeExport,
  StockMovementPivotReport,
  StockPivotReport,
  StockPivotExport,
  EstimatedProductionBalanceReport: (params) => {
    return APIService.get(`/v01/reports/estimated-production-balance`, {
      params: {
        ...params
      },
    });
  },
  EstimatedProductionBalanceExport: (params) => {
    return APIService.get(`/v01/reports/estimated-production-balance/export`, {
      params: {
        ...params
      },
      responseType: 'blob',
    });
  },
  StockOrderSummaryReport: (params) => {
    return APIService.get(`/v01/reports/stock-order-summary`, {
      params: {
        ...params
      },
    });
  },
  StockOrderSummaryExport: (params) => {
    return APIService.get(`/v01/reports/stock-order-summary/export`, {
      params: {
        ...params
      },
      responseType: 'blob',
    });
  },
  PurchaseHistory: (params) => {
    return APIService.get(`/v01/reports/purchase-history`, {
      params: {
        ...params
      },
    });
  },
  PurchaseHistoryExport: (params) => {
    return APIService.get(`/v01/reports/purchase-history/export`, {
      params: {
        ...params
      },
      responseType: 'blob',
    });
  },
  DailyStockSummaryReport: (params) => {
    return APIService.get(`/v01/reports/stock-summary`, {
      params: {
        ...params
      },
    });
  },
  DailyStockSummaryExport: (params) => {
    return APIService.get(`/v01/reports/stock-summary/export`, {
      params: {
        ...params
      },
      responseType: 'blob',
    });
  },
  DailyInventoryValuationReport: (params) => {
    return APIService.get(`/v01/reports/daily-inventory-valuation`, {
      params: {
        ...params
      },
    });
  },
  DailyInventoryValuationExport: (params) => {
    return APIService.get(`/v01/reports/daily-inventory-valuation/export`, {
      params: {
        ...params
      },
      responseType: 'blob',
    });
  },
};

export default ReportService;
